import { Box, Text, Heading } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { useTransactions } from "../context/TransactionsContext";
import { useCurrentMonth } from "../hooks/useCurrentMonth";
import { formatEuro } from "../utils/helperFunctions";

const COLORS = [
  "#E53E3E",
  "#D69E2E",
  "#38A169",
  "#3182CE",
  "#805AD5",
  "#718096",
];

export const CategoryChart = () => {
  const { transactions } = useTransactions();
  const currentMonth = useCurrentMonth();
  const [, setShowLabels] = useState(window.innerWidth > 390);

  useEffect(() => {
    const handleResize = () => {
      setShowLabels(window.innerWidth > 390);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const filteredTransactions = transactions.filter((t) => {
    const date = new Date(t.date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}` === currentMonth;
  });

  const categoryData = filteredTransactions
    .filter((tx) => tx.type === "expense")
    .reduce<Record<string, number>>((acc, tx) => {
      acc[tx.category] = (acc[tx.category] || 0) + tx.amount;
      return acc;
    }, {});

  const chartData = Object.entries(categoryData).map(([category, amount]) => ({
    name: category,
    value: amount,
  }));

  return (
    <>
      {chartData.length !== 0 ? (
        <Box
          mt={6}
          textAlign="center"
          height={{ base: "300px", md: "400px" }}
          pl={5}
        >
          <Heading size="lg">Ausgaben | nach Kategorien</Heading>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                outerRadius={100}
                fill="#8884d8"
                labelLine={false}
              >
                {chartData.map((_, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip
                formatter={(value: number) => formatEuro(value)}
                labelFormatter={(name) => `Kategorie: ${name}`}
              />
              {<Legend />}
            </PieChart>
          </ResponsiveContainer>
        </Box>
      ) : (
        <Text textAlign={"center"}>
          Es wurden noch keine Ausgaben in diesem Monat eingetragen!
        </Text>
      )}
    </>
  );
};
